import { useState } from "react";
import { Button } from "@/components/ui/button";
import {
  StipendExpense,
  StipendExpensesByViewDocument,
  useApproveOrRejectStipendExpenseMutation,
} from "@common/utils/graphql";
import { Check, X } from "@phosphor-icons/react";
import { useToast } from "@/components/ui/use-toast";
import { Row } from "@tanstack/react-table";
import { ApproveOrRejectStipendDialog } from "../../components/ApproveOrRejectStipendDialog";

const StatusCell = ({ row }: { row: Row<StipendExpense> }) => {
  const { toast } = useToast();
  const [isApproved, setIsApproved] = useState(false);

  const [approveOrReject, { loading }] =
    useApproveOrRejectStipendExpenseMutation({
      refetchQueries: [StipendExpensesByViewDocument],
    });

  const reviewStipend = async (employerNotes?: string): Promise<void> => {
    const id = row.original.stipendExpenseId;
    const employeeId = row.original.employeeId;
    try {
      const { data } = await approveOrReject({
        variables: {
          stipendExpenseId: id,
          isApproved,
          employeeId,
          employerNotes,
        },
      });
      if (
        data?.approveOrRejectStipendExpense.__typename !==
        "MutationApproveOrRejectStipendExpenseSuccess"
      ) {
        throw new Error();
      }
      toast({
        title: `Stipend successfully ${isApproved ? "approved" : "rejected"}`,
      });
    } catch (e) {
      toast({
        title: `Failed to ${isApproved ? "approve" : "reject"} stipend, please try again`,
        variant: "destructive",
      });
    }
  };

  return (
    <ApproveOrRejectStipendDialog
      isApproved={isApproved}
      isLoading={loading}
      employeeName={row.original.user.firstName}
      onConfirm={reviewStipend}
      renderTrigger={() => (
        <div className="float-right flex">
          <Button
            variant="secondary"
            size="icon"
            disabled={loading}
            onClick={() => setIsApproved(true)}
            className="mr-3"
          >
            <Check weight="bold" className="size-4 text-green-600" />
          </Button>
          <Button
            variant="secondary"
            size="icon"
            onClick={() => setIsApproved(false)}
            disabled={loading}
          >
            <X weight="bold" className="size-4 text-error" />
          </Button>
        </div>
      )}
    />
  );
};

export default StatusCell;
